import { Formik, Form, Field } from "formik";
import React, { startTransition } from "react";
import { Button } from "react-bootstrap";
import * as Yup from "yup";
import { Modal } from "react-bootstrap";
import { useNavigate, useNavigation } from "react-router-dom";

const Signup = ({ handleSignUpClose, handleLoginPopup, showSignUpModal }) => {
 const handleClickHere = () => {
  handleSignUpClose();
  handleLoginPopup();
 };
 const currentRoute = window.location.pathname;
 const navigation = useNavigate();
 const handleNavigation = (values) => {
  startTransition(() => {
   localStorage.setItem("powerConsumerValue", values.powerConsumer);
   navigation(`/registration_manager?tab=${values.powerConsumer}`);
  });
 };
 return (
  <>
   <Modal show={showSignUpModal} onHide={handleSignUpClose} size="md" centered>
    <Modal.Header closeButton>
     <Modal.Title>Sign up</Modal.Title>
    </Modal.Header>
    <div className="signup-popup-body">
     <Formik
      initialValues={{
       powerConsumer: "",
       ConsumptionAggregator: "",
       prosumer: "",
      }}
      validationSchema={Yup.object().shape({
       powerConsumer: Yup.string().required("must Required"),
      })}
      onSubmit={(values) => {
       handleNavigation(values);
      }}
     >
      {({ values, errors }) => {
       return (
        <Form className="signup-form">
         <div className="row">
          <div className=" col-md-6">
           <div className="form-check-flex">
            <Field
             type="radio"
             className=" form-check-input"
             id="powerConsumer1"
             name="powerConsumer"
             value={1}
             checked={1 == values.powerConsumer}
            />
            <label className=" form-check-label" htmlFor="powerConsumer1">
             Power Generator
            </label>
           </div>
          </div>

          <div className=" col-md-6">
           <div className="form-check-flex">
            <Field
             type="radio"
             className=" form-check-input"
             id="powerConsumer2"
             name="powerConsumer"
             value={2}
             checked={2 == values.powerConsumer}
            />
            <label className=" form-check-label" htmlFor="powerConsumer2">
             Power Consumer
            </label>
           </div>
          </div>
         </div>
         <div className="row mt-4">
          <div className=" col-md-6">
           <div className="form-check-flex">
            <Field
             type="radio"
             className=" form-check-input"
             id="powerConsumer3"
             name="powerConsumer"
             value={3}
             checked={3 == values.powerConsumer}
            />
            <label className=" form-check-label" htmlFor="powerConsumer3">
             Prosumer
            </label>
           </div>
          </div>
          <div className="col-md-6">
           <div className="form-check-flex">
            <Field
             type="radio"
             id="powerConsumer4"
             className="form-check-input"
             name="powerConsumer"
             value={4}
             checked={4 == values.powerConsumer}
            />
            <label className="form-check-label" htmlFor="powerConsumer4">
             Discom
            </label>
           </div>
          </div>
         </div>
         {/* <div className="row mt-4">
          <div className=" col-md-6">
           <div className="form-check-flex">
            <Field
             type="radio"
             disabled
             className=" form-check-input"
             name="ConsumptionAggregator"
             value={4}
             checked={5 == values.ConsumptionAggregator}
            />
            <label
             className=" form-check-label label-2"
             htmlFor="ConsumptionAggregator"
            >
             Consumption Aggregator
            </label>
           </div>
          </div>

          <div className=" col-md-6">
           <div className="form-check-flex">
            <Field
             type="radio"
             disabled
             className=" form-check-input"
             name="ConsumptionAggregator"
             value={5}
             checked={5 == values.ConsumptionAggregator}
            />
            <label
             className=" form-check-label label-2"
             for="ConsumptionAggregator"
            >
             Generation Aggregator
            </label>
           </div>
          </div>
         </div> */}
         <div className="text-center mt-4 fw-bold">
          <Button type="submit" className="btn btn-lg btn-signup py-3">
           Proceed <i className=" fa fa-angle-right ps-3"></i>
          </Button>
         </div>
        </Form>
       );
      }}
     </Formik>
     {currentRoute !== "/analyst_dashboard" && (
      <div className="mt-4 fw-medium existing_user">
       <div className="popup-ftr-text">Are You Already an Existing User?</div>
       <div>
        <a
         className="popup-ftr-text-link"
         onClick={handleClickHere}
         style={{ cursor: "pointer" }}
        >
         Click Here
        </a>
       </div>
      </div>
     )}
    </div>
    <div
     className="fw-medium existing_user justify-content-center"
     style={{ color: "#3f3f3f" }}
    >
     For any assistance, please write to us at{" "}
     <div className="popup-ftr-text-link" color="#FF7D00">
      &nbsp;info@gna.energy
     </div>
    </div>
   </Modal>
  </>
 );
};

export default Signup;
